import Typography from '@mui/material/Typography';

import colors from '../colors';
import Button from "@mui/material/Button";

const LauncherFeatureClearButton = ({ clickCallback, label }) => {
    return <Button
        onClick={ clickCallback }
        sx={{
            height: "44px",
            color: colors.secondaryText,
            borderRadius: "8px",
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: colors.optionBorder,
            boxShadow: colors.optionShadow,
            marginLeft: '24px',
            textTransform: 'none',
            '& .MuiTypography-root': {
                paddingTop: '2px',
                marginLeft: '16px',
                marginRight: '16px',
                fontWeight: 600,
            }
        }}
    >
        <Typography> {label || "Clear Selected"} </Typography>
    </Button>;
};

export default LauncherFeatureClearButton;
